import * as React from 'react';
import { Lazy } from 'components/common/lazy/lazy';
import { RenderImageProps } from './title';
import { TitleImage } from './title-image';

interface TitleThumbnailProps {
  imageUrl: string;
  lazyLoadImg: boolean;
  renderImg: RenderImageProps;
}

export const TitleThumbnail: React.FunctionComponent<TitleThumbnailProps> = ({ imageUrl, lazyLoadImg, renderImg }) => (
  <React.Fragment>
    {lazyLoadImg && (
      <Lazy key={`lazy-${imageUrl}`} loadOffset={{ top: 350, bottom: 350 }}>
        <Lazy.Placeholder key={`lazy-placeholder-${imageUrl}`}>
          <TitleImage renderImg={renderImg} serverRender={true} />
        </Lazy.Placeholder>
        <Lazy.Loaded key={`lazy-loaded-${imageUrl}`}>
          <TitleImage src={imageUrl} loaded={true} renderImg={renderImg} serverRender={true} />
        </Lazy.Loaded>
      </Lazy>
    )}
    {!lazyLoadImg && <TitleImage src={imageUrl} loaded={true} renderImg={renderImg} serverRender={true} />}
  </React.Fragment>
);
